import { FC } from "react";
import { ICellRendererParams } from "ag-grid-community";
import { TypographyWithTooltip } from "@/components/common/TypographyWithTooltip";
import { SnowflakeConnection } from "@/services/cloudchipr.api";

export const SnowflakeConnectionNameCellRenderer: FC<
  ICellRendererParams<SnowflakeConnection>
> = ({ data }) => {
  if (!data) {
    return;
  }

  return <TypographyWithTooltip title={data?.name} variant="body2" />;
};
